import { render, staticRenderFns } from "./ChannelMemberOptions.vue?vue&type=template&id=1f8710f2"
import script from "./ChannelMemberOptions.vue?vue&type=script&lang=js"
export * from "./ChannelMemberOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports